export type CreatePostModalSize = "2xl" | "xl" | "full-screen";

export const getCreatePostModalSize = ({
  isLgScreen,
  isXlScreen,
}: {
  isLgScreen: boolean;
  isXlScreen: boolean;
}): CreatePostModalSize => {
  if (isXlScreen) {
    return "2xl";
  }

  if (isLgScreen) {
    return "xl";
  }

  return "full-screen";
};
